<template>
  <div class="content-webhook-api">
    <el-card>
      <h3>Request Body</h3>
      <textarea id="editor"></textarea>

      <hr>
      <el-button type="primary" :loading="submitting" @click="executeApi">Execute</el-button>
      <hr>
      <h3>Responses</h3>
      <div v-loading="submitting">
        <textarea id="result"></textarea>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  testWebhook
} from '@/api/project';

  import * as Codemirror from 'codemirror'
  import 'codemirror/lib/codemirror.css'
  import 'codemirror/theme/mbo.css'
  import 'codemirror/mode/javascript/javascript.js'
  export default {
    props: {
      project: String,
    },
    data(){
      return {
        editor: null,
        submitting:false,
        responses: "",
        content: `
{
  "type": "statement",
  "data": {

  }
}
`
      }
    },
    methods:{
      setupEditor(){
        this.editor = Codemirror.fromTextArea(document.getElementById('editor'),{ 
          theme: 'mbo',
          mode: 'application/json',
          autoRefresh:true,
          lineNumbers: true,
          styleActiveLine: true,
          matchBrackets: true
        })


        this.responses = Codemirror.fromTextArea(document.getElementById('result'),{ 
          theme: 'mbo',
          mode: 'application/json',
          autoRefresh:true,
          lineNumbers: true,
          styleActiveLine: true,
          matchBrackets: true,
          readOnly: 'nocursor'
        })


        this.editor.setValue(this.content);
       
      },
      setupResponses(content){
        this.responses.setValue(content);
        setTimeout(()=> {
          this.responses.refresh();
        },100);
      },
      executeApi(){
        if(!this.project){
          this.$notify({
            title: 'Error',
            message: `Please select project`,
            type: 'error',
            duration: 2000
          });
          return false;
        }
        this.submitting = true;
        testWebhook(this.project, JSON.parse(this.content)).then(json => {
          this.submitting = false;
          this.setupResponses(JSON.stringify(json, null, 2))
        })
      }
    },
    mounted(){
      this.setupEditor()
    },
    beforeMount(){
      setTimeout(()=> {
          this.editor.refresh();
        },100);
    }
  }
</script>

<style lang="scss" scoped>
</style>